var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03453 0.421281C1.45343 2.08909 0.260167 3.64413 0 5.16868C0.0430881 8.60807 3.28648 12.867 7.18392 16.7586C11.0608 20.6297 15.551 24.4513 18.8152 23.9566C20.3494 23.6959 21.9145 22.4933 23.5963 20.9004C24.1365 20.3852 24.1362 19.2768 23.5856 18.727L20.2662 15.4127C19.6937 14.8411 18.5833 14.8408 17.8541 15.2267L15.6195 16.8626C14.427 17.8787 11.9145 15.3858 10.2467 13.7204C8.58267 12.059 6.04353 9.80294 7.11385 8.34535L8.74764 6.12038C9.12857 5.39967 9.1283 4.29119 8.58242 3.74612L5.27613 0.44479C4.68634 -0.144178 3.57594 -0.144452 3.03446 0.421461L3.03453 0.421281Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIconPhone);
export default __webpack_public_path__ + "static/media/input_icon_phone.00bb055cf6e6c8c38a7d752220bf5c3a.svg";
export { ForwardRef as ReactComponent };